(function(){
  var CLUB_PATH='/pages/creer-gamme-textile-club-padel';

  function isClubPage(){
    return window.location.pathname.replace(/\/$/,'')===CLUB_PATH;
  }

  function hide(el){
    if(!el) return;
    el.style.setProperty('display','none','important');
    el.style.setProperty('visibility','hidden','important');
    el.style.setProperty('height','0','important');
    el.style.setProperty('min-height','0','important');
    el.style.setProperty('max-height','0','important');
    el.style.setProperty('margin','0','important');
    el.style.setProperty('padding','0','important');
    el.style.setProperty('overflow','hidden','important');
    el.style.setProperty('opacity','0','important');
    el.setAttribute('aria-hidden','true');
  }

  function addPageClass(){
    if(!isClubPage()) return;
    document.documentElement.classList.add('impulse-club-page-only');
    if(document.body) document.body.classList.add('impulse-club-page-only');
  }

  function injectCSS(){
    if(!isClubPage() || document.getElementById('impulse-club-page-kill')) return;
    var style=document.createElement('style');
    style.id='impulse-club-page-kill';
    style.textContent='html.impulse-club-page-only footer .group-block:has(.email-signup),html.impulse-club-page-only footer .group-block:has(.email-signup-block),html.impulse-club-page-only footer .group-block:has(.newsletter-form),html.impulse-club-page-only footer .group-block:has(.impulse-club-copy),html.impulse-club-page-only footer .group-block:has(.impulse-club-static),html.impulse-club-page-only footer .group-block:has([class*=newsletter]),html.impulse-club-page-only footer .group-block:has([class*=email-signup]),html.impulse-club-page-only footer .impulse-newsletter-hardfix,html.impulse-club-page-only footer .impulse-newsletter-zone,html.impulse-club-page-only footer .impulse-club-copy,html.impulse-club-page-only footer .impulse-club-static,html.impulse-club-page-only footer .newsletter-form,html.impulse-club-page-only footer .email-signup,html.impulse-club-page-only footer .email-signup-block{display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;max-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;opacity:0!important;}';
    document.head.appendChild(style);
  }

  function hideAutoPageTitle(){
    if(!isClubPage()) return;
    var landing=document.querySelector('.impulse-club-landing');
    if(!landing) return;
    var h1s=[].slice.call(document.querySelectorAll('main h1'));
    h1s.forEach(function(h1){
      if(landing.contains(h1)) return;
      var text=(h1.textContent||'').trim().toLowerCase();
      if(text==='créer la gamme textile de mon club'){
        var block=h1.closest('.shopify-block') || h1.closest('[data-block-id]') || h1.closest('.text-block') || h1.parentElement;
        hide(block);
      }
    });
  }

  function removeNewsletterBlock(){
    if(!isClubPage()) return;
    addPageClass();
    injectCSS();
    hideAutoPageTitle();

    var selectors=[
      'footer .impulse-newsletter-hardfix',
      'footer .impulse-newsletter-zone',
      'footer .impulse-club-copy',
      'footer .impulse-club-static',
      'footer .newsletter-form',
      'footer .email-signup',
      'footer .email-signup-block',
      'footer [class*=newsletter]',
      'footer [class*=email-signup]'
    ];

    selectors.forEach(function(selector){
      document.querySelectorAll(selector).forEach(function(el){
        var block=el.closest('.group-block') || el.closest('.shopify-section') || el;
        hide(block);
      });
    });
  }

  removeNewsletterBlock();
  document.addEventListener('DOMContentLoaded',removeNewsletterBlock);
  document.addEventListener('shopify:section:load',removeNewsletterBlock);
  window.addEventListener('load',removeNewsletterBlock);

  var pending=false;
  new MutationObserver(function(){
    if(pending) return;
    pending=true;
    requestAnimationFrame(function(){
      pending=false;
      removeNewsletterBlock();
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
